import { render } from "./ProjectsItemDatasetDeleted.vue?vue&type=template&id=421334aa"
import script from "./ProjectsItemDatasetDeleted.vue?vue&type=script&lang=js"
export * from "./ProjectsItemDatasetDeleted.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__